import { combineReducers } from 'redux'
import apiKeys, { State as ApiKeysState } from './api-keys-store'

export interface State {
  apiKeys: ApiKeysState
}

export default combineReducers<State>({ apiKeys })
